import { render } from "./AListItem.vue?vue&type=template&id=27bd99a2"
import script from "./AListItem.vue?vue&type=script&lang=js"
export * from "./AListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__